import { useCallback, useMemo } from 'react';
import { SavedSearch } from '@types';
import useGetDevices from '@hooks/api/queries/collections/useGetDevices';
import { SelectedDataPoint } from '@components/_shared/DataPointSearch/types';
import {
  createDeviceLookupMaps,
  convertToHistorianDataPoint,
} from '../utils/historianSearchUtils';

export function useDataPointConverter(
  setActiveSearch: React.Dispatch<React.SetStateAction<SavedSearch>>,
) {
  const { data: devices = [] } = useGetDevices();

  const deviceMaps = useMemo(() => createDeviceLookupMaps(devices), [devices]);

  const addDataPointsFromSearch = useCallback(
    (selectedDataPoints: SelectedDataPoint[]) => {
      const newDataPoints = selectedDataPoints.map((point) =>
        convertToHistorianDataPoint(point, deviceMaps),
      );

      setActiveSearch((prev) => {
        const hasEmptyFirstDataPoint =
          prev.dataPoints.length === 1 &&
          !prev.dataPoints[0].category &&
          !prev.dataPoints[0].dataPoint;

        return {
          ...prev,
          dataPoints: hasEmptyFirstDataPoint
            ? newDataPoints
            : [...prev.dataPoints, ...newDataPoints],
        };
      });
    },
    [deviceMaps, setActiveSearch],
  );

  return { addDataPointsFromSearch };
}
